import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './styles/base.css'
import './styles/ui.css'
import './styles/layout.css'
import './styles/app.css'
import { App } from './app/App'
import { registriereServiceWorker } from './lib/sw-registrierung'

void registriereServiceWorker()

const wurzel = document.getElementById('wurzel')
if (!wurzel) throw new Error('Wurzelelement fehlt')
createRoot(wurzel).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
